import React from 'react';
import useScrollSync from '@/hooks/useScrollSync';

export default function ScrollSyncWrapper({ children, className = '' }) {
  const { topRef, bottomRef, overflow, handleTopScroll, handleBottomScroll } =
    useScrollSync();

  return (
    <div className={`scroll-sync-wrapper ${className}`}>
      {/* Top scrollbar — only shown when content overflows */}
      {overflow.hasOverflow && (
        <div
          ref={topRef}
          className="scroll-sync-track"
          onScroll={handleTopScroll}
        >
          {/* Ghost element with the exact content width so the scrollbar range matches */}
          <div style={{ width: overflow.scrollWidth, height: 1 }} />
        </div>
      )}

      {/* Content wrapper — the bottom scrollbar lives here */}
      <div
        ref={bottomRef}
        className="scroll-sync-content"
        onScroll={handleBottomScroll}
        style={{ overflowX: 'auto' }}
      >
        {children}
      </div>
    </div>
  );
}
